import { request } from "@/utils/request";
/**
 * 查询
 * @param {*} data 
 * @returns 
 */
export function selectApi(data) {
  return request({
    url: `/admin/storeAccountMapping/select`,
    method: "POST",
    data,
  });
}

/**
 * 新增
 * @param {*} data 
 * @returns 
 */
export function addApi(data) {
  return request({
    url: `/admin/storeAccountMapping/add`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data 
 * @returns 
 */
export function deleteApi(data) {
  return request({
    url: `/admin/storeAccountMapping/delete`,
    method: "POST",
    data,
  });
}
